import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import Add from './components/add';
import List from './components/list';
import Item from './components/item';

const propTypes = {
	overflow: PropTypes.array,
	showListOfFilters: PropTypes.bool,
	selectedFilters: PropTypes.array,
	listOfFilters: PropTypes.array,
	showFiltersList: PropTypes.func,
	deleteFilter: PropTypes.func,
	addFilterValue: PropTypes.func,
	deleteFilterValue: PropTypes.func,
	deleteFilterByName: PropTypes.func,
	clearFilterValue: PropTypes.func,
	loadFilterOptions: PropTypes.func,
	toggleInverseFilterValue: PropTypes.func,
	intl: PropTypes.func,
	deleteAllFilters: PropTypes.func,
	toggleFilterBlock: PropTypes.func
};

//todo Now display only 5 filters. In future implement horizontal-scroll container.
const Filters = props => (
	<div className="filters-container clearfix">
		{props.selectedFilters.map((filter, i) => (
			<Item
				{...props}
				{...filter}
				onAddValue={props.addFilterValue}
				onDeleteValue={props.deleteFilterValue}
				onDeleteItem={props.deleteFilterByName}
				onClearValue={props.clearFilterValue}
				onLoadOptions={props.loadFilterOptions}
				onToggleInverse={props.toggleInverseFilterValue}
				onCloseOptions={props.closeFilterOptionsByName}
				onBlockFilter={props.toggleFilterBlock}
				shouldOpenOptionsByName={props.filters.shouldOpenOptionsByName}
				intl={props.intl}
				key={i} />
		))}

		{props.showListOfFilters && <List {...props} />}

		{!!props.selectedFilters.length && (
			<div className="filters-container__control filters__left">
				{props.listOfFilters.length > 0 && props.selectedFilters.length < 5 && (
					<button
						className="ui-btn ui-btn-primary btn-add-filter"
						onClick={() => props.showFiltersList()} />
				)}
				<button
					className="ui-btn ui-btn-secondary btn-remove-filter"
					onClick={props.deleteAllFilters} />
			</div>
		)}

		{!props.selectedFilters.length && !props.showListOfFilters && <Add {...props} />}

	</div>
);

Filters.propTypes = propTypes;

class FiltersContainer extends React.Component {
	componentDidMount() {
		if (this.props.onShow) {
			this.props.onShow();
		}
	}

	render() {
		return <Filters {...this.props} />;
	}
}

export default FiltersContainer;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/filters/main.js